import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { formatInvoiceNumber } from "../../../helpers/format";
import { TwoLineGridCell } from "../../TransactionsDataGrid/renderers";

import { GridInvoice } from "../../../types";

interface Props extends ICellRendererParams {
  data: GridInvoice;
}

const InvoiceNumberRenderer = ({ data }: Props) => {
  const { invoiceNumber } = data;

  return (
    <TwoLineGridCell firstLineData={formatInvoiceNumber(invoiceNumber, "")} />
  );
};

export default InvoiceNumberRenderer;
